export const SERVICE_ADD_REQUEST = "SERVICE_ADD_REQUEST";
export const SERVICE_ADD_SUCCESS = "SERVICE_ADD_SUCCESS";
export const SERVICE_ADD_FAILURE = "SERVICE_ADD_FAILURE";

export const SERVICE_VIEW_REQUEST = "SERVICE_VIEW_REQUEST";
export const SERVICE_VIEW_SUCCESS = "SERVICE_VIEW_SUCCESS";
export const SERVICE_VIEW_FAILURE = "SERVICE_VIEW_FAILURE";

export const SERVICE_VIEW_ALL_REQUEST = "SERVICE_VIEW_ALL_REQUEST";
export const SERVICE_VIEW_ALL_SUCCESS = "SERVICE_VIEW_ALL_SUCCESS";
export const SERVICE_VIEW_ALL_FAILURE = "SERVICE_VIEW_ALL_FAILURE";

export const SERVICE_UPDATE_REQUEST = "SERVICE_UPDATE_REQUEST";
export const SERVICE_UPDATE_SUCCESS = "SERVICE_UPDATE_SUCCESS";
export const SERVICE_UPDATE_FAILURE = "SERVICE_UPDATE_FAILURE";

export const SERVICE_DELETE_REQUEST = "SERVICE_DELETE_REQUEST";
export const SERVICE_DELETE_SUCCESS = "SERVICE_DELETE_SUCCESS";
export const SERVICE_DELETE_FAILURE = "SERVICE_DELETE_FAILURE";

export const FETCH_ALL_SERVICES_REQUEST = "FETCH_ALL_SERVICES_REQUEST";
export const FETCH_ALL_SERVICES_SUCCESS = "FETCH_ALL_SERVICES_SUCCESS";
export const FETCH_ALL_SERVICES_FAILURE = "FETCH_ALL_SERVICES_FAILURE";

export const RESET_SERVICE_DETAILS = "RESET_SERVICE_DETAILS";
export const UPDATE_SERVICE_APPROVAL_REQUEST =
  "UPDATE_SERVICE_APPROVAL_REQUEST";
export const UPDATE_SERVICE_APPROVAL_SUCCESS =
  "UPDATE_SERVICE_APPROVAL_SUCCESS";
export const UPDATE_SERVICE_APPROVAL_FAILURE =
  "UPDATE_SERVICE_APPROVAL_FAILURE";
